import { NgModule } from '@angular/core';

import { VbNavigationHandlerDirective } from 'rev-shared/uiRouterUtils/VbNavigationHandler.Directive';

import { AppUtilService } from './AppUtil.service';
import { LanguageCodes } from './LanguageCodes.Service';

const declarations = [
	VbNavigationHandlerDirective
];

@NgModule({
	declarations,
	exports: declarations,

	providers: [
		AppUtilService,
		LanguageCodes
	]
})
export class UtilAngularModule {}
